<template>
<v-dialog v-model="dialogEditShow" max-width="1200px" persistent>
  <v-card class="pa-4 pa-sm-8 test-editor">
    <h4 class="mb-5">Редактирование общего домена</h4>
    <v-btn class="button-close ma-4" icon @click="dialogEditShow=false">
      <v-icon>mdi-close</v-icon>
    </v-btn>
    <BlockOverallCard :block="curBlock" :instrument="instrument" :domain="true" />
  </v-card>
</v-dialog>
</template>

<script>
import BlockOverallCard from '@/components/testEditor/BlockOverallCard.vue';

/**
 * Компонент: EditDomainOverallDialog
 * Описание:
 */
export default {
  name: 'EditDomainOverallDialog',

  components: { BlockOverallCard },

  props: {
    value: Boolean,
    instrument: Object
  },

  data() {
    const curBlock = null;
    return {
      curBlock,
    };
  },

  computed: {
    dialogEditShow: {
      get() {
        return this.value;
      },
      set() {
        this.$emit('input', false);
      }
    },
  },

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {},
};
</script>

<style scoped lang="scss">
.EditDomainOverallDialog {
  /* Стили компонента */
}
</style>
